import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import CustomsItem from 'app/models/customs_item';

export default PageableBase.extend({
  model: CustomsItem,
  key: 'customs_items',
  url: appUrl('customs_items'),
});



// WEBPACK FOOTER //
// ./app/collections/customs_items.js